var _line, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.366211,
    y1: 2.46152,
    x2: 12.6338,
    y2: 2.46152,
    stroke: "#828A9A",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77326 2.27273L5.77326 0.5L7.22852 0.5L7.22852 2.27273L5.77326 2.27273Z",
    fill: "#828A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28613 3.06152V11.6134C2.28613 12.1657 2.73385 12.6134 3.28613 12.6134H9.71422C10.2665 12.6134 10.7142 12.1657 10.7142 11.6134V3.06152",
    stroke: "#828A9A",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50996 9.80606L4.50996 5.34106L5.70996 5.34106L5.70996 9.80606L4.50996 9.80606Z",
    fill: "#828A9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29121 9.80606L7.29121 5.34106L8.49121 5.34106L8.49121 9.80606L7.29121 9.80606Z",
    fill: "#828A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.7690753acb25cc57a19edf516f88842a.svg";
export { ForwardRef as ReactComponent };